import { jsx } from 'react/jsx-runtime';
import { ListContainer, ListItem } from './DotSeparatedList.styles.js';

const DotSeparatedList = ({ items, separatorColor, alignItems, gap = 8, flexWrap, justifyContent, }) => {
    return (jsx(ListContainer, Object.assign({ alignItems: alignItems, justifyContent: justifyContent, flexWrap: flexWrap }, { children: items.map(({ id, node, show = true }, index) => show && (jsx(ListItem, Object.assign({ id: id, separatorColor: separatorColor, gap: gap }, { children: node }), index))) })));
};

export { DotSeparatedList as default };
//# sourceMappingURL=DotSeparatedList.js.map
